module.exports = __webpack_public_path__ + "static/img_8-7a43e63966e0bb716fc54cd2bd792b42.png";